import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session18/bitter-reach-page-banner-session-18.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./forbidden-lands-styles.scss";

import tharik from "../../../../src/assets/forbidden-lands/session18/tharik-ironoath.webp";
import barukun from "../../../../src/assets/forbidden-lands/session18/barukun.webp";
import mul from "../../../../src/assets/forbidden-lands/session18/muls-shadow-show.mp4";
import cover from "../../../../src/assets/forbidden-lands/session18/fbl-session-18-cover.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const FBLSession18 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Tower of the Farseers",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={cover}
            caption="Session 18"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Session 18: Tower of the Farseers. At last the Tower of the Farseers is discovered, Ailin the dwarf
                tells of his father, and Mul's Shadow Show unveils deeper
                mystery of The Five Seals."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          At the stronghold, a{" "}
          <span style={{ color: "burlywood" }}>
            band of FIFTY Frostwind orcs led by Luronk (Session 16: Aasare's
            Harpoon) arrives back at Ruenlocke
          </span>
          . They were given information by Tuuwa (Session 15: To the Tower, Part
          2) who posed as a friendly worker to gain access to layout, persons,
          and access points to the strongheld. The fate of the secondary PCs at
          Ruenlock will enter center stage next session.
          <br />
          <br />
          Meanwhile, the party near the Tower of the Farseers are now in the
          Southern Range mountains of the Bitter Reach. The party approaches the
          tower stretching into the unseen heights of the blizzard sky. The
          tower is a narrow, tall spire of black stone that seems to be carved
          from the very rock of the mountains. It is adorned with intricate
          carvings and runes from the age of Rodenvale, the Bitter Reach before
          the demons came and where locked away behind the Five Seals as
          Rodenvale descended into eternal winter. The gate to the tower is
          shattered into pieces buired in drifting snow from recent, powerful
          magic. There is a corpse near the gaping maw into the tower.
          <br />
          <br />
          As Lobo and Zenith approach, Lobo realizes{" "}
          <span style={{ color: "burlywood" }}>
            the body is that of the goblin guide Tiemiesz from Company Zed
            (Session 06: Ruins of Ruenlocke)
          </span>
          .
          <br />
          <br />
          Tiemiesz is frozen solid. His leather armor is torn open as if the
          goblin was trying to desperately shed his clothing. Inside the tower
          is a simple, hollow tower with nothting but ledges jutting from the
          walls along the shaft disappearing into the darkness above. There are
          no stairs, no windows, nothing. Scattered on the floor of the
          unfurnished tower are three bodies; two of expired Alderlander
          treasure hunters and one that appears to be a barely discerinble blod
          of diseased, oozing flesh; dead but forboding.
          <br />
          <br />
          Leaning against the wall of the tower next to a long-dead fire, is a
          dwarf. As Lobo approaches, the eyes of the dwarf open. He grins,
          barely, and says:{" "}
          <span style={{ color: "lightgreen" }}>
            "Aye, it's Lobo. Still as furry as every my friend"
          </span>
          , and we realize{" "}
          <span style={{ color: "burlywood" }}>
            the dwarf is Eileen, the leader of Company Zed
          </span>
          . They had attempted to rob the Brothers of the Bitter Reach, but
          later accompanied them and helped take Ruenlocke and became allies.
          Zenith builds a fire, Erollo heals the dwarf, and Lobo asks Eileen
          what has happened.
          <br />
          <br />
          Eileen tells how they found a party at the tower also investigating
          the comet. Based on fever dreams while he has sat broken and COLD for
          days,{" "}
          <span style={{ color: "burlywood" }}>
            Eileen believes the party got to the top of the tower and mortally
            wounded the guardian Mul from the legends
          </span>
          . He tells also of Misgrown arriving at the tower. The infectious blod
          creature was one of them. Eileen reveals that despite being healed, he
          is dying from infection as he shows his left side riddled with
          pustulent, necrotic flesh. Lobo ponders if the Blissxer potions they
          found in Ruenlocke would help. He decides to gamble one of the
          potions. Turns out it could help; it's a 50/50 dice roll. The dice
          rolls and it looks like Eileen will be dying.
          <br />
          <br />
          <ImageComponent
            image={barukun}
            caption="Barukun"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Barukun is a necklace of stone carved into an unbreakable knot. It is a symbol of the Canide dwarves of the Southern Peaks, guardians of the Winding Ways. Show it and you will be known as a dwarf-friend. It is inscribed with Airin's name as well so they will know that you knew him."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Before expiring next to a warm fire near companions, Eileen reveals
          his name is Airin which is dwarven from Ai: vow, oath and Rin
          (pronounced "reen"): steel, resolve. Airin's name means "Vow of
          Steel". He gives Lobo a necklace of stone carved into an unbreakable
          knot.{" "}
          <span style={{ color: "lightgreen" }}>
            "This is a Barakun my friend. A symbol of my people, the Canide
            dwarves of the Southern Peaks, guardians of the Winding Ways. Show
            it and you will be known as a dwarf-friend. It is inscribed with my
            name as well so they will know that you knew me."
          </span>
          Airin flutters in and out of consciousness. He tells the tale of his
          father, Tharik Ironoath. As the end, he looks deep into Lobo's eyes.
          Moments pass and Ailin's eyes go from livin orbs to glassy marbles; he
          is dead.
          <br />
          <br />
          <ImageComponent
            image={tharik}
            caption="Tharik Ironoath"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Ailin Ironoath is a Canide dwarf and leader of Company Zed. His father was Tharik Ironoath and this is his story.<br/><br/><i>            <div style={{ color: 'lightgreen' }}>              Airin Ironoath was born amid the cold stones of Southwatch Crag,              one of the Canides' high passes in the Southern Heights — where              dwarves guard the mountain ways against human expansion from the              north. His father, Tharik Ironoath, was one of the finest              Pathkeepers of his age: a mapwalker, ice tracker, and protector of              The Winding Ways. He walked where others would not, and listened              where others talked.            </div>            <br />            <div style={{ color: 'lightgreen' }}>              But Tharik held secrets like a forge holds fire.            </div>            <br />            <div style={{ color: 'lightgreen' }}>              Old lorewhisperers tell of the <strong>Forgethralls</strong>,              dwarves once enslaved by the cruel winter elf-king{' '}              <strong>Ferenblaud</strong>, who bound their souls to ancient              forges carved beneath elven ruins. There, under the icecap, the              dwarves labored as smiths of living weapons. Only death could end              their bondage. When Ferenblaud's kingdom shattered, the world              thought the Forgethralls died with it — but a few endured,              retreating deeper into the ice. Their bloodlines thinned and              vanished... or so the world believed.            </div>            <div style={{ color: 'lightgreen' }}>              Tharik was obsessed with a hidden <strong>ice-road</strong>{' '}              beneath the Southern Range — a passage long sealed by quake or              collapse. He believed it connected the high passes to{' '}              <strong>something older, deeper</strong>. In his final winter, he              vanished into the far west mountains with a single message              scrawled in stone ash in his room:            </div>            <br />            <div style={{ color: 'lightgreen' }}>              <strong>                “Some chains outlast the masters. Some fires still burn in the                dark. I go where the kin do not.”              </strong>            </div>          </i>"
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <span style={{ color: "lightblue" }}>
            <strong>The Story of Tharik Ironoath</strong>
          </span>
          <br />
          <i>
            <div style={{ color: "lightgreen" }}>
              Airin Ironoath was born amid the cold stones of Southwatch Crag,
              one of the Canides' high passes in the Southern Heights — where
              dwarves guard the mountain ways against human expansion from the
              north. His father, Tharik Ironoath, was one of the finest
              Pathkeepers of his age: a mapwalker, ice tracker, and protector of
              The Winding Ways. He walked where others would not, and listened
              where others talked.
            </div>
            <br />
            <div style={{ color: "lightgreen" }}>
              But Tharik held secrets like a forge holds fire.
            </div>
            <br />
            <div style={{ color: "lightgreen" }}>
              Old lorewhisperers tell of the <strong>Forgethralls</strong>,
              dwarves once enslaved by the cruel winter elf-king{" "}
              <strong>Ferenblaud</strong>, who bound their souls to ancient
              forges carved beneath elven ruins. There, under the icecap, the
              dwarves labored as smiths of living weapons. Only death could end
              their bondage. When Ferenblaud's kingdom shattered, the world
              thought the Forgethralls died with it — but a few endured,
              retreating deeper into the ice. Their bloodlines thinned and
              vanished... or so the world believed.
            </div>
            <div style={{ color: "lightgreen" }}>
              Tharik was obsessed with a hidden <strong>ice-road</strong>{" "}
              beneath the Southern Range — a passage long sealed by quake or
              collapse. He believed it connected the high passes to{" "}
              <strong>something older, deeper</strong>. In his final winter, he
              vanished into the far west mountains with a single message
              scrawled in stone ash in his room:
            </div>
            <br />
            <div style={{ color: "lightgreen" }}>
              <strong>
                “Some chains outlast the masters. Some fires still burn in the
                dark. I go where the kin do not.”
              </strong>
            </div>
          </i>
          |
          <br />
          Highlights of the exploration of the tower include:
          <ul>
            <li>Finding body of Shima on ledge and getting her down.</li>
            <li>
              Using the artifact Aasare's harpoon to climb section by section up
              the tower.
            </li>
            <li>
              Erollo takes a fall to the floor of the tower; alive, unbroken but
              badly hurt. He stays as Lobo and Zeninth finish the climb.
            </li>
            <li>
              Mortally wounded shadow dragon Mul in huge chamber at top of
              tower. Threed dead bodies of treasure hunters scattered on the
              floor. Above, the top of the tower is blown open, apparently a
              gaping wound where the seal of the tower was and now gone from
              explosive release of the magic. Strangely the open ceiling shows
              not the icy sky of the Bitter Reach but dark abyss filled with
              stars. Erollo sees in his minds eye as Mul projects his story into
              the minds of all living creatures in the tower, and Erollo
              realizes the stars appear in positions they would have had
              thousands of years ago when the Reach was Rodenvale.
            </li>
            <li>Party sees Mul's Shadow Show</li>
          </ul>
          <center>
            <h2>Mul's Shadow Show</h2>
          </center>
          <video
            width="100%"
            height="auto"
            controls
            source
            src={mul}
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
          <br />
          <br />
          <small>Attendees: Erollo, Lobo, and Zenith.</small>
          <br />
          <small>Ending Datetime: 6pm, Springrise 18, 1165</small>
          <h5>XP</h5>
          <ul>
            <li>Session 1.0</li>
            <li>Legend: 0.0</li>
            <li>Lore: 0.2 (Tharik Ironoath told by Airin Ironoath)</li>
            <li>Hex: 1.0</li>
            <li>Pride: 0.0</li>
            <li>Treasure: 1.0</li>
            <li>Monster: 0.0</li>
            <li>Dark Secret: 0.0</li>
            <li>
              <strong>TOTAL: 3.2</strong>
            </li>
          </ul>
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a href="#freedom-day" name="pageTop">
                  <img
                    src={logo}
                    style={{ maxWidth: "200px" }}
                    alt="Forbidden Lands Campaign"
                  />
                </a>
              </main>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <img src={sectionDivider} alt="section divider" />
            <Card.Body>
              <Card.Title
                id="cardTitle-forbidden-lands"
                className="cardTitle-forbidden-lands  "
              >
                At last the Tower of the Farseers is discovered, Ailin the dwarf
                tells of his father, and Mul's Shadow Show unveils deeper
                mystery of The Five Seals.
                <br />
                <br />
                <small>
                  ⇐ Sessions 16-17:{" "}
                  <a href="./forbidden-lands-session-16_17">Aasare's Harpoon</a>
                  {/* ☠
                  Session 17:{" "}
                  <a href="./forbidden-lands-session-17">
                    TBD
                  </a>{" "}
                  ⇒{" "} */}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FBLSession18;
